module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "shop-tags-wrapper"
  }, [_c('div', {
    staticClass: "header-wrapper"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.shopInfo.name) + " / 商品分类管理")]), _vm._v(" "), _c('div', {
    staticClass: "btn-group"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.handleShowTagDialog('new')
      }
    }
  }, [_vm._v("添加标签")])], 1)]), _vm._v(" "), _c('ul', {
    staticClass: "tags-list"
  }, _vm._l((_vm.tags), function(tag, index) {
    return _c('li', {
      key: tag.id,
      staticClass: "tag-wrapper",
      attrs: {
        "draggable": "true"
      },
      on: {
        "dragstart": function($event) {
          return _vm.handleDrag(index, $event)
        },
        "dragenter": function($event) {
          $event.preventDefault();
        },
        "dragover": function($event) {
          $event.preventDefault();
        },
        "drop": function($event) {
          return _vm.handleDrop(index, $event)
        }
      }
    }, [_c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(tag.name))]), _vm._v(" "), _c('span', {
      staticClass: "count"
    }, [_vm._v("商品数量" + _vm._s(tag.product_count))]), _vm._v(" "), _c('span', {
      staticClass: "edit",
      on: {
        "click": function($event) {
          return _vm.handleShowTagDialog('edit', tag)
        }
      }
    }, [_vm._v("编辑")]), _vm._v(" "), _c('span', {
      staticClass: "edit",
      on: {
        "click": function($event) {
          return _vm.handleDelTag(tag.id)
        }
      }
    }, [_vm._v("删除")])])
  }), 0), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.dialog.title,
      "size": "tiny"
    },
    model: {
      value: (_vm.dialog.visable),
      callback: function($$v) {
        _vm.$set(_vm.dialog, "visable", $$v)
      },
      expression: "dialog.visable"
    }
  }, [_c('div', [_c('el-input', {
    attrs: {
      "placeholder": "请输入标签名称"
    },
    model: {
      value: (_vm.dialog.tagName),
      callback: function($$v) {
        _vm.$set(_vm.dialog, "tagName", $$v)
      },
      expression: "dialog.tagName"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialog.visable = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleTagSave
    }
  }, [_vm._v("确 定")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-06307efa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/shop/tags.vue
// module id = 801
// module chunks = 1